import { Region } from 'constants/shop';

export interface PetTypeTokens {
  dog: string[];
  cat: string[];
}

// Tokens are matched as substrings of a lowercased url, so 'hunde' also covers 'hundefutter'.
const PET_TYPE_TOKENS_DE: PetTypeTokens = {
  dog: ['dog', 'hunde', 'welpe', 'puppy'],
  cat: ['cat', 'katzen', 'katze', 'katz', 'kitten'],
};

const PET_TYPE_TOKENS_NL: PetTypeTokens = {
  dog: ['dog', 'honden', 'hond', 'puppy', 'pup'],
  cat: ['cat', 'katten', 'kat', 'kitten'],
};

// Switzerland shares the German routes.
export const PET_TYPE_TOKENS_BY_REGION: Record<Region, PetTypeTokens> = {
  [Region.DE]: PET_TYPE_TOKENS_DE,
  [Region.CH]: PET_TYPE_TOKENS_DE,
  [Region.NL]: PET_TYPE_TOKENS_NL,
};
